import {styled} from '@mui/system';

export const MuiButtonSection = styled('div')(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	width: '100%',
	justifyContent: 'flex-end',
	marginBottom: theme.spacing(4),
}));
